import { render, staticRenderFns } from "./ReviewActionLink.vue?vue&type=template&id=5064c9b3&scoped=true&"
import script from "./ReviewActionLink.vue?vue&type=script&lang=js&"
export * from "./ReviewActionLink.vue?vue&type=script&lang=js&"
import style0 from "./ReviewActionLink.vue?vue&type=style&index=0&id=5064c9b3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5064c9b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VIcon,VTextField})
